export default __webpack_public_path__ + "static/char-s-55-en-6792a26bcada90d58fd81f63fc81e857.webp";